import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import FlowsIndex from './Index.vue';
import FlowEditor from './FlowEditor.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/flows'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => ({ name: 'flows_list', params: to.params }),
        },
        {
          path: 'list',
          name: 'flows_list',
          component: FlowsIndex,
          meta: { permissions: ['administrator'] },
        },
      ],
    },
    {
      // The canvas needs the full viewport, so it sits outside SettingsWrapper's
      // centered, padded column. `edit/` keeps the param from competing with
      // the static `list` path above.
      path: frontendURL('accounts/:accountId/settings/flows/edit/:flowId'),
      name: 'flows_edit',
      component: FlowEditor,
      meta: { permissions: ['administrator'] },
    },
  ],
};
